import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability'
import store from '../redux/store'


//Defines how to detect object's type
function subjectName(item) {
  // console.log('ability subjectName item: ' + item);
  // console.log('ability subjectName typeof item: ' + typeof item);

  if(!item || typeof item === 'string') {
      console.log('ability subjectName return item:' + item);
      return item;
  }

  return item.__type;
}

export const ability = new Ability([], { subjectName })

let currentAuth;
store.subscribe(() => {
    // console.log("ability store.subscribe called currentAuth: "  + JSON.stringify(currentAuth));
    
    const prevAuth = currentAuth;
    //console.log("ability store.subscribe prevAuth:"+ JSON.stringify(prevAuth));
    //console.log("ability store.subscribe store.getState():"+ JSON.stringify(store.getState()));

    currentAuth = store.getState().authreducer.user;
    //console.log("ability store.subscribe NOW currentAuth: "  + JSON.stringify(currentAuth));

    if(prevAuth !== currentAuth) {
      try{
        ability.update(defineRulesFor(currentAuth));
        //console.log("ability store.subscribe NOW ability: " + JSON.stringify(ability));        
      }
      catch(error){
        console.log("ability store.subscribe error: " + error);

      }

    }

});

export const defineRulesFor = (user) => {
    // console.log("ability defineRulesFor called user: " + JSON.stringify(user));
    //const { can, cannot, rules } = new AbilityBuilder();
    const { can, cannot, rules } = AbilityBuilder.extract();
    // console.log("ability defineRulesFor called rules: " + JSON.stringify(rules));
    // console.log("ability defineRulesFor called user.role_name: " + JSON.stringify(user.role_name ));

    try{
      if (user.role_name === 'ADMIN'){
        can('manage', 'all', { userId: user.accessToken} ); // read-write access to everything
        can('view', 'Consignment')
      }
      if (user.role_name === 'EDITOR'){
        // can('view', 'Consignment')
        can('add', 'Consignment')
        can('accept', 'Application')
        can('reject', 'Application') 
        can('view', 'PendingReviews')  
        can('view', 'Consignment')
        can('view', 'Proposal') 
        //can('read', 'all') // read-only access to everything 
      }      
      if (user.role_name === 'MANAGER'){
          // can('view', 'Consignment')
          can('add', 'Consignment')
          can('accept', 'Application')
          can('reject', 'Application') 
          can('view', 'PendingReviews')  
          //can('read', 'all') // read-only access to everything 
      }
      if (user.role_name === 'VENDOR'){
          can('review', 'Proposal')    
      }  
      if (user.role_name === 'VIEWER')
      {
          can('view', 'Consignment')
          can('view', 'Proposal')    
      }  
    }
    catch(error){
      console.log("ability defineRulesFor error: " + error);
    }


    //console.log("ability defineRulesFor rules: " + JSON.stringify(rules));

    return rules;
}

export default ability;